var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-main',[_c('h2',[(_vm.address)?_c('span',[_vm._v(_vm._s(_vm.address))]):_c('span',[_vm._v("正在定位当前位置")]),_c('i',{staticClass:"el-icon-position"})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }